module.exports = __webpack_public_path__ + "img/calq.9ba01cfb.png";